/* eslint-disable no-unused-vars */
import Dialog, { setDefaults } from "a11y-dialog-component";
import { classes } from "../../variables.json";

document.addEventListener("click", delegateTriggerEvents, false);

setDefaults({
	documentDisabledClass: classes["body-lock"],
	delay: 300
});

/**
 * Returns new Dialog instance.
 *
 * @param {string} selector Element ID
 * @param {object} options Dialog configuration object
 *
 * @example
 *  const menu = dialogFactory('#dialog-menu', {labelledby: 'menu-title'})
 *
 * @see https://github.com/jonathanlevaillant/a11y-dialog-component
 */
export function dialogFactory(selector, options) {
	const settings = {
		openingSelector: ".js-dialog-open",
		closingSelector: ".js-dialog-close",
		backdropSelector: selector,
		onOpen(element) {
			element.classList.add("is-open");
		},
		onClose(element) {
			setTimeout(() => {
				element.classList.remove("is-open");
			}, this.delay);
		},
		...options
	};
	return new Dialog(selector, settings);
}

const basket = dialogFactory("#sideview-basket", {
	openingSelector: ".js-basket-open",
	labelledby: "sideview-basket-title"
});

const sidemenu = dialogFactory("#sideview-menu", {
	openingSelector: ".js-sidemenu-open"
});

const support = dialogFactory("#sideview-support", {
	openingSelector: ".js-support-form",
	labbeledby: "sideview-support-title"
});

const cashback = dialogFactory("#sideview-cashback", {
	openingSelector: ".js-cashback-form",
	labbeledby: "sideview-cashback-title"
});

const meeting = dialogFactory("#sideview-meeting", {
	openingSelector: ".js-meeting-form",
	labbeledby: "sideview-meeting-title"
});

const friends = dialogFactory("#sideview-friends", {
	openingSelector: ".js-friends-form",
	labbeledby: "sideview-friends-title"
});

const ratingAdvisor = dialogFactory("#sideview-rating-advisor", {
	openingSelector: ".js-rating-advisor",
	labbeledby: "sideview-rating-advisor-title"
});

const ratingProduct = dialogFactory("#sideview-rating-product", {
	openingSelector: ".js-rating-product",
	labbeledby: "sideview-rating-product-title"
});

/**
 * Delegate event for Tippy controlled dropdowns
 */
function delegateTriggerEvents({ target }) {
	if (target.closest(".js-friends-form")) friends.open();
}
